//import liraries
import React, { useEffect } from 'react';
import AddCompanyService from '../../services/AddCompanyService';
import { Button, MenuItem, Select, TextField, FormControl, InputLabel, CircularProgress } from '@mui/material';
import { useAuth } from '../../AuthProvider';
import AddInviteService from '../../services/AddInviteService';
import RetrieveCompanyList from '../../services/RetrieveCompanyList';

// create a component
const Invite = (props) => {
  const userContext = useAuth();
  const [formData, setFormData] = React.useState({ companyId: '', companyName: '', email: '', locationId: '', role: 'ROLE_EMPLOYEE' });
  const [response, setResponse] = React.useState(null);
  const [companyList, setCompanyList] = React.useState([]);
  const [loadingCompanies, setLoadingCompanies] = React.useState(false);
  const authContext = useAuth();
  const isSadmin = authContext.role === 'ROLE_SADMIN';

  useEffect(() => {
    if (isSadmin) {
      const ownCompany = authContext.additionalUserInfo?.company || {};
      const ownCompanyId = ownCompany.id || ownCompany.companyId || '';
      const ownCompanyName = ownCompany.companyName || authContext.additionalUserInfo?.companyName || '';
      if (ownCompanyId) {
        setFormData((prev) => ({ ...prev, companyId: ownCompanyId, companyName: ownCompanyName }));
      }
      setLoadingCompanies(true);
      RetrieveCompanyList(authContext.token)
        .then((data) => setCompanyList(Array.isArray(data) ? data : []))
        .catch(() => setCompanyList([]))
        .finally(() => setLoadingCompanies(false));
    } else {
      const company = authContext.additionalUserInfo?.company || {};
      setFormData((prev) => ({ 
        ...prev,
        companyName: company.companyName || authContext.additionalUserInfo?.companyName || '',
        companyId: company.id || company.companyId || authContext.additionalUserInfo?.companyId || '',
        locationId: authContext.additionalUserInfo?.locationId || '',
      }));
    }
  }, [isSadmin, authContext.token, authContext.additionalUserInfo]);

  const handleCompanySelect = (event) => {
    const selectedId = event.target.value;
    const selectedCompany = companyList.find((c) => (c.id || c.companyId) === selectedId);
    setFormData((prev) => ({
      ...prev,
      companyId: selectedId,
      companyName: selectedCompany?.companyName || selectedCompany?.name || '',
      locationId: selectedCompany?.locationId || '',
    }));
  };

  const saveRecord = async () => {
    const payload = {
      ...formData,
      locationId: formData.locationId || authContext.additionalUserInfo.locationId || null,
    };
    const result = await AddInviteService(payload, userContext.token);
    console.log(result);
    setResponse(result);
  };

  const handleChangeSelect = (event) => {
    setFormData({ ...formData, role: event.target.value });
  };

  return (
    <div>
      <div>
        {isSadmin ? (
          loadingCompanies ? (
            <CircularProgress size={20} />
          ) : (
            <FormControl className="textField" fullWidth style={{ marginBottom: 16 }}>
              <InputLabel id="company-select-label">Company</InputLabel>
              <Select
                labelId="company-select-label"
                value={formData.companyId}
                label="Company"
                onChange={handleCompanySelect}
              >
                {companyList.map((c) => (
                  <MenuItem key={c.id || c.companyId} value={c.id || c.companyId}>
                    {c.companyName || c.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          )
        ) : (
          <TextField className="textField" disabled id="company-name" label="Company Name" variant="outlined" value={formData.companyName} onChange={() => {}} />
        )}
      </div>
      <TextField className="textField" id="firstName" label="First name" onChange={(e) => { setFormData({ ...formData, firstName: e.target.value }); }} variant="outlined" value={formData.firstName || ''} />
      <TextField className="textField" id="lastName" label="Last name" onChange={(e) => { setFormData({ ...formData, lastName: e.target.value }); }} variant="outlined" value={formData.lastName || ''} />
      <TextField className="textField" id="email" label="Email" onChange={(e) => { setFormData({ ...formData, email: e.target.value }); }} variant="outlined" value={formData.email || ''} />
      <div>Select a role</div>
      <Select className='selectField'
        labelId="role-select-label"
        id="role-select"
        value={formData.role}
        label="Role"
        onChange={handleChangeSelect}
      >
        <MenuItem value={'ROLE_EMPLOYEE'}>Employee</MenuItem>
        <MenuItem value={'ROLE_MANAGER'}>Manager</MenuItem>
        <MenuItem value={'ROLE_CMANAGER'}>Company Manager</MenuItem>
        <MenuItem value={'ROLE_FMANAGER'}>Finance Manager</MenuItem>
      </Select>
      <Button className="buttonField" variant="contained" onClick={saveRecord}>Invite User</Button>

      <div>
        {response != null ? 'Invitation is sent for this user' : ''}
      </div>
    </div>
  );
};

export default Invite;
